import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Grid, Row, Col } from 'react-bootstrap';
import YouTube from 'react-youtube';

import { inject, observer } from 'mobx-react';

import { ImageHeader, ImageHeading } from '../components/OnePager/ImageSectionStyle'
import { LightBackground } from '../components/GeneralStyle'
import GoogleMapReact from 'google-map-react';

import { Center, LogeButtonSlim } from '../components/GeneralStyle'
import { ResiLogo, GoldenBg } from './ResidenceStyle'
import { InfoBox } from '../components/OnePager/OnePageStyle'
import { Inverse, InverseH1, InverseH3, InverseP } from '../components/OnePager/AboutStyle'

import headerImage from '../images/residence/residence.jpeg'
import resiLogo from '../images/residence/TL_Res.png'
import wappen from '../images/wappen.png'

import ReactGA from "react-ga";

const AnyReactComponent = ({ text }) => <div style={{ backgroundImage: `url(${wappen})`, marginTop: -95, marginLeft: -37, height: 95, width: 75, backgroundSize: 'cover', backgroundPosition: 'center center' }}></div>;

@inject('userStore')

@observer
class CompanyGrid extends Component {

  trackGa() {

    ReactGA.event({
      category: 'Residence',
      action: 'Click Button',
      label: 'Contact - CTA'
    });
  }

  render() {
    const { isResidenceRole } = this.props.userStore;
    const defaultProps = {
      center: {
        lat: 36.5064268,
        lng: -4.9621745
      },
      zoom: 13
    };

    const paddingLeft = 10
    const paddingRight = 10

    const opts = {
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        mute: 1
      }
    };

    return (
      <Grid fluid>
        <LightBackground className={"fillScreen"} style={{ backgroundColor: 'white' }}>
          <ImageHeader style={{ height: 'calc(100vh + 60px)', top: -60 }} background={headerImage} >
            <ImageHeading style={{ fontSize: '4em', letterSpacing: 6 }}>
              <ResiLogo src={resiLogo} />
            </ImageHeading>
          </ImageHeader>
          <div className={'content-wrapper'}>

            <Inverse>
              <Center marginTop={0} marginBottom={0} style={{ paddingTop: 100, paddingBottom: 100, margin: 'auto' }} className={'content-wrapper'}>
                <Row style={{ paddingBottom: 100 }}>
                  <InverseH1 style={{ letterSpacing: '0.2em', fontSize: 40, paddingBottom: 15 }}>Über die Residence</InverseH1>
                  <Col smOffset={3} sm={6}>
                    <InverseP style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                      Das Apartment liegt in einer der besten Gegenden in Marbella. 10 Minuten von Puerto Banus und 5 Minuten von den besten Lokalen in Marbella entfernt.<br />
                      Zwei Schlafzimmer mit eigenem Bad, ein großes Wohnzimmer, eine schöne Terrasse mit Blick auf den Golfplatz Aloha, Parkplätze vor der Tür und ein großes Pool machen einen Aufenthalt mit 4 Personen dort sehr gemütlich.<br />
                      Mit einem Upgrade unserer Mitgliedschaft um 1.400 Euro/Jahr habt Ihr die Möglichkeit dieses Apartment 2 Wochen pro Jahr zu nutzen.
                </InverseP>
                    {isResidenceRole
                      ? <LogeButtonSlim
                        onClick={() => this.props.history.push("/internal/residence")}
                        color={"#DAB777"} hoverFontColor={"white"} fontColor={"#DAB777"}
                        style={{ margin: 25 }}>
                        zu den Residence Buchungen</LogeButtonSlim>
                      : ''}

                  </Col>
                </Row>
                <br />
                <Row>
                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior.jpeg')}
                      />
                    </InfoBox>
                  </Col>

                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior2.jpeg')}
                      />
                    </InfoBox>
                  </Col>

                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior3.jpeg')}
                      />
                    </InfoBox>
                  </Col>
                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior6.jpg')}
                      />
                      <InverseH3>Full Service</InverseH3>
                      <InverseP>
                        Schlüsselübergabe und Reinigung sind bereits organisiert.
  Wenn wir ankommen, ist die Wohnung gereinigt, neue Bettwäsche überzogen und frische Handtücher liegen ebenfalls bereit. Frau Coco wird uns die Schlüssel übergeben und alle relevanten Details (Gas, Alarmanlage, etc.) erklären.
  Mit € 100,-, welche gleich bei Ankunft in bar an Frau Coco zu zahlen sind, ist ihr Service und die Reinigung der Wohnung beglichen.
                  </InverseP>
                    </InfoBox>
                  </Col>

                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior5.jpg')}
                      />
                      <InverseH3>Limitierte Nutzung</InverseH3>
                      <InverseP>
                        Die Buchungen werden über unseren elektronischen Kalender auf der Webseite erfasst.
  Für die Nutzung des Apartments ist es Voraussetzung, dass ihr selbst oder eure Partner / Familie mit dabei sind.
  Das Einladen von Freunden, ohne selbst dabei mit zu fahren ist nicht gestattet.
  Im Bedarfsfall bitte im Vorfeld mit uns abstimmen.
                  </InverseP>
                    </InfoBox>
                  </Col>

                  <Col sm={12} md={4} lg={4}>
                    <InfoBox paddingLeft={paddingLeft} paddingRight={paddingRight} style={{ maxWidth: 400, margin: 'auto' }}>
                      <img
                        style={{ width: '100%' }}
                        alt="lint.."
                        src={require('../images/residence/interior4.jpg')}
                      />
                      <InverseH3>Exklusive Angebote</InverseH3>
                      <InverseP>
                        Jedes Mitglied bekommt natürlich auch eine Villa Padierna Card, welche euch einen 40% Nachlass auf die Green-Fees der gesamten Anlage ermöglicht. Dieser Rabatt gilt auch für eure Begleiter!
                  </InverseP>
                    </InfoBox>
                  </Col>
                </Row>
              </Center>
            </Inverse>
            <Row>
              <div style={{ maxWidth: 1600, margin: 'auto', paddingBottom: 150, paddingLeft: '10%', paddingRight: '10%' }}>
                <YouTube
                  className={"youtube"}
                  containerClassName={"video-container"}
                  videoId="CCzeOVcHPiw"
                  opts={opts}
                  onReady={this._onReady}
                />

              </div>
            </Row>
          </div>
          <GoldenBg>

            <div style={{ maxWidth: 1600, margin: 'auto' }}>
              <Row
              >
                <Col xs={12}>
                  <h2 style={{ textAlign: 'center', width: '100%' }}>
                    Haben wir Ihr Interesse geweckt?
                </h2>
                  <p style={{ textAlign: 'center' }}>
                    Dann freuen wir uns über Ihre Anfrage via Mail
                </p>
                </Col>
                <Col xs={12} style={{ textAlign: 'center' }}>
                  <a onClick={() => this.trackGa()} href="mailto:kontakt@the-loge.com">
                    <LogeButtonSlim
                      color={"white"} hoverFontColor={"#DAB777"} fontColor={"white"}
                      style={{ margin: 25 }}>
                      Hier kontaktieren</LogeButtonSlim>
                  </a>
                </Col>
              </Row>

            </div>
          </GoldenBg>
          <div style={{ height: 450, width: '100%' }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: "AIzaSyAOPylrd5pEGLh2cfpQ5JpEYydmKAsTr_c" }}
              defaultCenter={defaultProps.center}
              defaultZoom={defaultProps.zoom}
            >
              <AnyReactComponent
                lat={36.5064268}
                lng={-4.9621745}
                text="My Marker"
              />
            </GoogleMapReact>
          </div>
        </LightBackground >
      </Grid >
    );
  }
}

export default withRouter(CompanyGrid)



// WEBPACK FOOTER //
// /src/pages/Residence.js